import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { Modal } from '@pc/components/modal/modal';
import BaseButton from '../atoms/button/BaseButton';

interface Props {
  close?: boolean;
  onClick: () => void;
  text: string;
  className?: string;
  isPending?: boolean;
}

export default function ModalFooter(props: Props) {
  const { close, onClick, text, className, isPending = false } = props;
  const { popModal } = useModalStore();

  return (
    <Modal.Footer className={cn('flex w-full gap-[8px]', className)}>
      {close && (
        <BaseButton
          variant='gray'
          className='h-[56px] flex-1'
          onClick={() => {
            popModal();
          }}
        >
          취소
        </BaseButton>
      )}
      <BaseButton variant='primary' className='h-[56px] flex-1' onClick={onClick} isPending={isPending}>
        {text}
      </BaseButton>
    </Modal.Footer>
  );
}
